"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  MailboxPost: ['mailbox-post', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M7.5.75A4.5,4.5,0,0,0,3,5.25v15H21v-15A4.5,4.5,0,0,0,16.5.75Z', 'M3 20.25L3 23.25', 'M21 20.25L21 23.25', 'M6.75 0.812L6.75 20.25', 'M17.25 0.812L17.25 20.25', 'M6.75 6.75L17.25 6.75', 'M10.5 11.25L14.25 13.5 10.5 15.75']],
  MailboxPost1: ['mailbox-post-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M5.25 5.25H18.75V23.25H5.25z', 'M3 5.25L21 5.25', 'M3.75 23.25L20.25 23.25', 'M18.75,5.25H5.25A4.5,4.5,0,0,1,9.75.75h4.5A4.5,4.5,0,0,1,18.75,5.25Z', 'M9 8.25L15 8.25', 'M15.75,23.25H8.25v-9a1.5,1.5,0,0,1,1.5-1.5h4.5a1.5,1.5,0,0,1,1.5,1.5Z', 'M12,15.75a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,15.75h0']],
  MailboxIn: ['mailbox-in', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12.75 18.75L12.75 23.25', 'M3.75,8.25h16.5a3,3,0,0,1,3,3V18a.75.75,0,0,1-.75.75H6.75v-7.5A3,3,0,0,0,3.75,8.25Z', 'M6.75,18.75H1.5A.75.75,0,0,1,.75,18V11.25a3,3,0,0,1,6,0Z', 'M11.25 11.25L11.25 0.75', 'M11.25,5.25H16.5a2.25,2.25,0,0,0,0-4.5H11.25Z']],
  MailboxHouse: ['mailbox-house', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.071,8.25,20.26,1.221a.751.751,0,0,0-.7-.471H4.079a.749.749,0,0,0-.7.471l-2.4,6a.75.75,0,0,0,.7,1.029h8.884a.751.751,0,0,0,.7-.471L14.071.75', 'M21.571,4.5v6.75a1.5,1.5,0,0,1-1.5,1.5H3.571a1.5,1.5,0,0,1-1.5-1.5v-3', 'M15.571 5.25L18.571 5.25', 'M12.571 12.75L12.571 23.25', 'M9.571 12.75L9.571 23.25']],
  MailboxFull: ['mailbox-full', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12 18.75L12 23.25', 'M21,8.25H6a3,3,0,0,0-3,3V18a.75.75,0,0,0,.75.75H21Z', 'M15 11.25L15 0.75', 'M15,5.25H10.5A1.5,1.5,0,0,1,9,3.75V2.25A1.5,1.5,0,0,1,10.5.75H15Z']]
};
exports["default"] = _default;